import { useMutation, useQueryClient } from '@tanstack/react-query';
import { collaboratorService } from '@/features/Collaborators/Services';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { collaboratorsQueryKeys } from './useCollaboratorsQuery';

export function useAddCollaboratorMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (formData: CollaboratorFormData) =>
            collaboratorService.addCollaborator(formData),
        onSuccess: () => {
            // When a new collaborator is added, invalidate the collaborators query
            // to refetch the list.
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
        },
    });
}

export function useUpdateCollaboratorMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (formData: CollaboratorFormData) =>
            collaboratorService.updateCollaborator(formData),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            // Invalida a query de detalhe para este colaborador específico
            if (variables.id) {
                queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
            }
        },
    });
}

export function usePartialUpdateCollaboratorMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (vars: { id: string; data: Partial<CollaboratorFormData> }) =>
            collaboratorService.updatePartialCollaborator(vars),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            // Invalida a query de detalhe para este colaborador específico
            if (variables.id) {
                queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
            }
        },
    });
}

export function useUpdateCollaboratorRatingMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, rating }: { id: string; rating: number }) =>
            collaboratorService.updateCollaboratorRating(id, rating),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
        },
    });
}

export function useUpdateCollaboratorSalaryMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, salary }: { id: string; salary: number }) =>
            collaboratorService.updateCollaboratorSalary(id, salary),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
        },
    });
}

export function useUpdateCollaboratorResourcesMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, resources }: { id: string; resources: any[] }) =>
            collaboratorService.updateCollaboratorResources(id, resources),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
        },
    });
}

export function useUpdateCollaboratorStatusMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, statusUpdate }: { id: string; statusUpdate: Record<string, any> }) =>
            collaboratorService.updateCollaboratorStatus(id, statusUpdate),
        onSuccess: (_, variables) => {
            // Lista de colaboradores é atualizada pelo listener em tempo real; não é necessário invalidar
            // queryClient.invalidateQueries({ queryKey: collaboratorsQueryKeys.all });
            queryClient.invalidateQueries({ queryKey: ['collaborator', variables.id] });
        },
    });
} 